<!-- Outline/Fill Variant -->
<mat-form-field 
  *ngIf="outline!=='plain'" 
  appearance="fill" 
  color="primary" 
  (click)="$event.stopPropagation();"
  [attr.aria-label]="label + ' search field'">
  
  <mat-label>{{ label }}</mat-label>
  
  <input 
    matInput 
    [formControl]="formControl"
    [attr.aria-label]="label"
    [attr.aria-required]="formControl.validator ? true : null"
    [attr.aria-invalid]="formControl.invalid && formControl.touched"
    (keydown.enter)="onSearch.emit(formControl.value)"
    #searchInput>
    
  <button 
    *ngIf="formControl.value" 
    matSuffix 
    mat-icon-button 
    type="button"
    [attr.aria-label]="'Clear search'" 
    (click)="clear(); searchInput.focus()">
    <mat-icon>close</mat-icon>
  </button>
  
  <button 
    *ngIf="!formControl.value" 
    matSuffix 
    mat-icon-button 
    type="button"
    [attr.aria-hidden]="true"
    tabindex="-1">
    <mat-icon>search</mat-icon>
  </button>
</mat-form-field>

<!-- Plain Variant -->
<div 
  *ngIf="outline==='plain'" 
  class="relative"
  [attr.aria-label]="label + ' search field'">
  
  <input 
    type="text" 
    [formControl]="formControl" 
    [placeholder]="label"
    [attr.aria-label]="label"
    [attr.aria-required]="formControl.validator ? true : null"
    [attr.aria-invalid]="formControl.invalid && formControl.touched"
    (keydown.enter)="onSearch.emit(formControl.value)"
    class="bg-white w-full rounded-md px-3 py-2 h-9 text-gray-500 border border-gray-300 text-sm outline-none pr-12"
    #plainSearchInput>
    
  <div class="absolute right-[13px] top-2 text-gray-400">
    <button 
      *ngIf="!formControl.value" 
      type="button"
      [attr.aria-hidden]="true"
      tabindex="-1">
      <mat-icon class="text-[18px]">search</mat-icon>
    </button>
    
    <button 
      *ngIf="formControl.value" 
      type="button"
      [attr.aria-label]="'Clear search'"
      (click)="clear(); plainSearchInput.focus()"
      class="cursor-pointer">
      <mat-icon class="text-[18px]">close</mat-icon>
    </button>
  </div>
</div>
